<div class="container" style="margin-top: 10rem;">
    <p>Aktivierung erforlgreich </p>
</div>